export const ICON_CLASSES_WARNING = 'w-5 h-5 text-warning-foreground';
